export default __webpack_public_path__ + "static/media/mode-540.b03b849b.svg";